import { processProviderRoutes } from "@/components/Web3/Common/Route/utils/processProviderRoutes";
import sortProcessedProviderRoutes from "@/components/Web3/Common/Route/utils/sortProcessedProviderRoutes";
import type { CalculateSuperPositions, SupCalculateRouteService, SupCalculateRouteToken, Web3TxRoutes } from "@/hooks/tx-flow/useDepositCalculate";
import type { SupTransactionType, SupWeb3Address, SupWeb3TxSingleVault } from "@/types";

export type RouteBadge = "output" | "gas" | "time";

export interface SupSinglePreparedRoute {
  approvalAddress: SupWeb3Address | undefined;
  erc20_route_approval_target: SupWeb3Address | undefined;
  badges: RouteBadge[];
  bridge?: SupCalculateRouteService;
  dex?: SupCalculateRouteService;
  difference: string;
  estimatedTime: string;
  fees: {
    gasCost: number;
    crossChainFee: number;
  };
  id: string;
  isERC20: boolean;
  service?: SupCalculateRouteService;
  toAmount: string;
  toAmountMin: string;
  toAmountInUsd: number;
  toMinAmount: string;
  toToken: SupCalculateRouteToken;
  vaultDecimals: number;
  vault_id: string;
  superPosition: CalculateSuperPositions;
  simulationAmount: string;
}

/**
 * Route preparation hook
 * Preparing data from two source object (LiFi routes & Socket routes) to display using unified interface object
 * inside the route card (src/Web3/Common/Route/Header.tsx)
 *
 * @param {Web3TxRoutes|undefined} routeData
 * @param {SupWeb3TxSingleVault} singleVault
 * @param {SupTransactionType} type
 * @return {SupSinglePreparedRoute[]}
 */
export default function prepareProviderRoutes(routeData: Web3TxRoutes | undefined, singleVault: SupWeb3TxSingleVault, type: SupTransactionType): SupSinglePreparedRoute[] {
  const formedRoutes = processProviderRoutes(routeData, singleVault, type);
  return sortProcessedProviderRoutes(formedRoutes);
}
